import { Link, useParams } from "react-router-dom";
import { getTypeIcon } from "../../../workflows/CreateCampaign/flow/flowSettings";
import { Anchor, Button } from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";

const CreateSMTP = ({ buttonProps, iconSize = 18, inReseller }) => {
  const lang = useLanguage((s) => s.language);

  const { poolId } = useParams();
  const route = poolId ? `/senders/pool/${poolId}/email/create/smtp` : `/senders/email/create/smtp`;

  return (
    <>
      {inReseller ? (
        <Anchor my={-8} size="sm" component={Link} to={route}>
          {lang.resellers.integration_smtp_add}
        </Anchor>
      ) : (
        <Button
          leftSection={getTypeIcon(
            "SMTP",
            false,
            iconSize,
            { variant: "subtle", color: "primary" },
            true,
          )}
          variant="subtle"
          w={"100%"}
          justify="start"
          c={"var(--mantine-color-gray-7)"}
          size="md"
          component={Link}
          to={route}
          {...buttonProps}
        >
          {lang.senders.emails.other_smtp}
        </Button>
      )}
    </>
  );
};

export default CreateSMTP;
